
import {
  defineComponent, PropType,
} from '@vue/composition-api';
import {
  useRoute, useRouter,
} from 'vue2-helpers/vue-router';

export default defineComponent({
  name: 'CategoryList',

  props: {
    categories: {
      type: Array as PropType<[string, number][]>,
      required: true,
    },
    legacy: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },

  setup(props) {
    const route = useRoute();
    const router = useRouter();

    const goTo = (category: string) => {
      const { query } = route;
      if (props.legacy) {
        router.replace({ query: { ...query, category } }).catch((error: Error) => {
          if (error.name !== 'NavigationDuplicated') {
            throw error;
          }
        });
        return;
      }
      const location = { name: 'Catalog', params: { category }, query: { q: query.q } };
      router.push(location).catch((error: Error) => {
        if (error.name !== 'NavigationDuplicated') {
          throw error;
        }
      });
    };
    return { goTo };
  },
});
